var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from "lit/decorators.js";
import { html, LitElement } from "lit";
import './FrameComponent';
import './FramePicker';
import './HelpCard';
import { HeapLayout } from "../HeapLayout";
import { helpCardTranslations } from "./HelpCard";
import './ExceptionCard';
let TraceComponent = class TraceComponent extends LitElement {
    reComputeLayouts() {
        this.layouts = [];
        if (!this._trace || this._trace.length === 0) {
            return;
        }
        let prev = null;
        for (let i = 0; i < this._trace.length; i++) {
            const frame = this._trace[i];
            prev = new HeapLayout(frame, prev);
            this.layouts.push(prev);
        }
    }
    constructor() {
        super();
        this.translations = helpCardTranslations;
        this.selectedFrame = 0;
        this.layouts = [];
        this._trace = [];
        this.reComputeLayouts();
    }
    update(changedProperties) {
        if (changedProperties.has("trace")) {
            this._trace = this.trace || [];
            this.reComputeLayouts();
            this.selectedFrame = Math.max(0, this._trace.length - 1);
        }
        super.update(changedProperties);
    }
    handleFrameChange(frame) {
        this.selectedFrame = frame;
    }
    addFrame(frame) {
        this._trace.push(frame);
        const lastLayout = this.layouts[this.layouts.length - 1];
        this.layouts.push(new HeapLayout(frame, lastLayout));
        this.requestUpdate();
    }
    render() {
        if (!this._trace || this._trace.length === 0 || !this.layouts || this.layouts.length === 0 || !this.layouts[this.selectedFrame]) {
            return html ``;
        }
        if (this._trace.length === 1 && this._trace[0].event === 'uncaught_exception') {
            return html `
                <tc-exception-card>
                    <span slot="title">The debugger crashed</span>
                    ${this._trace[0].exception_msg}
                </tc-exception-card>
            `;
        }
        return html `
            <tc-frame-picker 
                    .length=${this._trace.length}
                    .value=${this.selectedFrame}
                    @frame-change="${(e) => this.handleFrameChange(e.detail.frame)}"
            ></tc-frame-picker>
            ${this.selectedFrame > 0 ?
            this._trace[this.selectedFrame].event == 'uncaught_exception' ? html `
                    <tc-exception-card>
                        <span slot="title">The debugger crashed</span>
                        ${this._trace[this.selectedFrame].exception_msg}
                    </tc-exception-card>
                    ` : html `
                    <tc-frame 
                            .frame=${this._trace[this.selectedFrame]}
                            .layout=${this.layouts[this.selectedFrame]}
                    ></tc-frame>
            ` : html `
                <tc-help-card .translations=${this.translations}></tc-help-card>
            `}
        `;
    }
};
__decorate([
    property({ type: Array })
], TraceComponent.prototype, "trace", void 0);
__decorate([
    property({ type: Object })
], TraceComponent.prototype, "translations", void 0);
__decorate([
    property({ state: true })
], TraceComponent.prototype, "selectedFrame", void 0);
TraceComponent = __decorate([
    customElement('tc-trace')
], TraceComponent);
export { TraceComponent };
//# sourceMappingURL=TraceComponent.js.map